const vuexModules = {
    namespaced: true,
    state: {
        isLoading: true,
        isOpacityLoading: false
    },
    mutations: {
        setIsLoading (state, isLoading) {
            state.isLoading = isLoading;
        },
        // 画面非表示なしローディング
        setIsOpacityLoading (state, isOpacityLoading) {
            state.isOpacityLoading = isOpacityLoading;
        }
    }
};

export default vuexModules;
